/**
 * 学习乐园 · 连连看题材包：古诗上下句（lianliankan/pack-shici.js）
 * ---------------------------------------------------------------------------
 * 关联型配对：上句连下句（「床前明月光」连「疑是地上霜」）。note 存
 * 「《诗名》作者」——配上的那一瞬出处一并亮出来，背句子的同时记住
 * 这句是谁写的（消除与配错反馈双向展示）。
 * 收的都是小学必背名篇；5 言与 7 言混排，牌面字号按长度自动分档。
 * 20 对备 18 对/局，每局组合不同。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.shici = {
    id: 'shici',
    name: '古诗上下句',
    hint: '上句连下句，出处一并亮',
    kind: 'rel',
    cols: 6,
    rows: 6,
    pairs: [
      { l: '床前明月光', r: '疑是地上霜', note: '《静夜思》李白' },
      { l: '举头望明月', r: '低头思故乡', note: '《静夜思》李白' },
      { l: '春眠不觉晓', r: '处处闻啼鸟', note: '《春晓》孟浩然' },
      { l: '谁知盘中餐', r: '粒粒皆辛苦', note: '《悯农》李绅' },
      { l: '锄禾日当午', r: '汗滴禾下土', note: '《悯农》李绅' },
      { l: '白毛浮绿水', r: '红掌拨清波', note: '《咏鹅》骆宾王' },
      { l: '欲穷千里目', r: '更上一层楼', note: '《登鹳雀楼》王之涣' },
      { l: '离离原上草', r: '一岁一枯荣', note: '《草》白居易' },
      { l: '红豆生南国', r: '春来发几枝', note: '《相思》王维' },
      { l: '好雨知时节', r: '当春乃发生', note: '《春夜喜雨》杜甫' },
      { l: '小时不识月', r: '呼作白玉盘', note: '《古朗月行》李白' },
      { l: '春风又绿江南岸', r: '明月何时照我还', note: '《泊船瓜洲》王安石' },
      { l: '飞流直下三千尺', r: '疑是银河落九天', note: '《望庐山瀑布》李白' },
      { l: '两岸猿声啼不住', r: '轻舟已过万重山', note: '《早发白帝城》李白' },
      { l: '停车坐爱枫林晚', r: '霜叶红于二月花', note: '《山行》杜牧' },
      { l: '竹外桃花三两枝', r: '春江水暖鸭先知', note: '《惠崇春江晚景》苏轼' },
      { l: '不识庐山真面目', r: '只缘身在此山中', note: '《题西林壁》苏轼' },
      { l: '儿童散学归来早', r: '忙趁东风放纸鸢', note: '《村居》高鼎' },
      { l: '粉骨碎身浑不怕', r: '要留清白在人间', note: '《石灰吟》于谦' },
      { l: '孤帆远影碧空尽', r: '唯见长江天际流', note: '《黄鹤楼送孟浩然之广陵》李白' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
